/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useEffect, useState } from 'react'
import ActionsMenu from '~/components/shared/ActionsMenu'
import { useModal } from '~/contexts/ModalContext'
import ArtifactProperties from './ArtifactProperties'

interface PackageEntry {
  id: number
  docTypeId: number | string
  selected?: boolean
  name?: string
}

interface TableMenuProps {
  item: {
    id: number
    level: string
    entries: PackageEntry[]
  }
  setPckgData: (updater: (prev: any) => any) => void
  removeEntry: () => void
  duplicateEntry: () => void
  index: number
}

interface MenuItem {
  value: string
  action: () => void
  disabled?: boolean
}

const TableMenu: React.FC<TableMenuProps> = ({ item, setPckgData, removeEntry, duplicateEntry, index }) => {
  const { showModal } = useModal()
  const [isOpen, setIsOpen] = useState(false)
  const [items, setItems] = useState<MenuItem[]>([
    {
      value: 'LOADING...',
      action: () => {},
      disabled: true
    }
  ])

  const setOptions = () => {
    const menu: MenuItem[] = []
    menu.push({
      value: 'ACTION_DUPLICATE',
      action: () => {
        duplicateEntry()
      }
    })
    menu.push({
      value: 'ACTION_REMOVE',
      action: () => {
        removeEntry()
      }
    })
    menu.push({
      value: 'Properties',
      action: () => {
        const selectedEntries = getSelectedRows(item?.entries)
        if (
          selectedEntries?.length > 1 &&
          getSelectedRows(item?.entries)
            .map((e) => e.id)
            .includes(item?.entries?.[index]?.id)
        ) {
          showModal(
            <ArtifactProperties
              level={item?.level}
              setPckgData={setPckgData}
              documentTypeId={item?.entries?.[index]?.docTypeId}
              docTypeIds={selectedEntries.map((e) => Number(e.docTypeId))}
              options={{ selectedIds: getSelectedRows(item?.entries).map((e) => e.id) }}
              artifact={{ id: item?.entries?.[index]?.id, name: item?.entries?.[index]?.name || '' }}
            />,
            { keepParentModalsOpen: true }
          )
        } else {
          showModal(
            <ArtifactProperties
              level={item?.level}
              setPckgData={setPckgData}
              documentTypeId={item?.entries?.[index]?.docTypeId}
              docTypeIds={selectedEntries.map((e) => Number(e.docTypeId))}
              artifact={{ id: item?.entries?.[index]?.id, name: item?.entries?.[index]?.name || '' }} //check if this is proper
            />,
            { keepParentModalsOpen: true }
          )
        }
      }
    })
    setItems(menu)
  }

  const getSelectedRows = (items: PackageEntry[]): PackageEntry[] => {
    return items.filter(function (item) {
      return item?.selected === true
    })
  }

  useEffect(() => {
    setOptions()
  }, [item, isOpen])

  return (
    <>
      <ActionsMenu
        menuId={`action-menu-workflows-${item.id}`}
        onToggle={(open) => {
          setIsOpen(open)
        }}
        items={items}
      />
    </>
  )
}

export default TableMenu
